import { useGetContact } from 'generated/api-client/@tanstack/react-query.gen';
import { findKeycloakUsers } from 'utils';
import React, { FunctionComponent, useEffect } from 'react';
import ProContactDeleteConfirmModalContainer from './pro-contact-delete-confirm-modal-container';
import { ProContactDeleteConfirmModalProps } from './pro-contact-delete-confirm-modal-view';
import { useProContactDeleteConfirmModalQueryLazyQuery } from 'generated/graphql';
import { useQuery } from '@tanstack/react-query';

type ProContactDeleteConfirmModalRepositoryProps =
  ProContactDeleteConfirmModalProps & {
    currentProViewId?: number;
    contactId: number;
    contactEmail?: string;
    onConfirm?: (contactId: number) => void;
  };

const ProContactDeleteConfirmModalRepository: FunctionComponent<
  ProContactDeleteConfirmModalRepositoryProps
> = ({
  contactId,
  contactEmail,
  currentProViewId,
  onConfirm,
  onClose,
  ...rest
}) => {
  const { data: authUsers, isLoading: authUsersLoading } = useQuery({
    queryKey: ['keycloakUsers', contactEmail],
    queryFn: () =>
      findKeycloakUsers({ email: contactEmail, exact: true, limit: 1 }),
  });

  const [getData, { data, loading }] =
    useProContactDeleteConfirmModalQueryLazyQuery();

  const { data: contact } = useGetContact({
    path: {
      contactId: contactId,
    },
  });

  useEffect(() => {
    getData({
      variables: {
        skipRelatedProViewAccounts: !authUsers?.[0]?.id,
        authUserId: authUsers?.[0]?.id ?? 'undefined',
        proPersonId: contactId,
      },
    });
  }, [authUsers]);

  return (
    <ProContactDeleteConfirmModalContainer
      contact={contact}
      data={data}
      loading={loading || authUsersLoading}
      currentProViewId={currentProViewId}
      contactId={contactId}
      onClose={onClose}
      onConfirm={onConfirm}
      {...rest}
    />
  );
};
export default ProContactDeleteConfirmModalRepository;
